import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import LandingHeader from '../LandingHeader';
import Footer from '../Footer';

const MainLayout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LandingHeader />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout; 